var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination",class:_vm.position},[_c('div',{staticClass:"content"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 50, 100, 500],"page-size":_vm.per_page,"total":_vm.total,"layout":"total, sizes, prev, pager, next, jumper"},on:{"size-change":_vm.changeSize,"current-change":_vm.changePage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }